/**
 * The explanation, out of the way until it is wanted.
 *
 * Some screens carry rules that matter and are read once: how ingestion is
 * guarded, what the verdict labels are allowed to say, why a release exists.
 * Printed on the page they push the actual material below the fold - the 法令
 * screen spent two cards and a dozen lines on prose above a list of four
 * documents - and printed anywhere they are still the same words nobody reads
 * twice.
 *
 * A dialog, not a tooltip: this is a paragraph or a checklist, it has to be
 * scrollable and dismissable, and it must reach the keyboard. A tooltip that
 * holds six sentences is a dialog that forgot to say so.
 */
import { useState, type ReactNode } from 'react';
import { Modal } from './Modal.tsx';

export function InfoButton({
  title,
  label = 'この画面について',
  children,
}: {
  title: string;
  /** The accessible name. The button itself is an icon. */
  label?: string;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="infobtn"
        aria-label={label}
        title={label}
        onClick={() => setOpen(true)}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             strokeWidth="2" strokeLinecap="round" aria-hidden>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 11v5M12 7.6v.2" />
        </svg>
      </button>

      <Modal open={open} onClose={() => setOpen(false)} title={title}>
        <div className="infobody">{children}</div>
        <div className="editpanel__actions">
          <button className="btn btn--ghost" type="button" onClick={() => setOpen(false)}>
            閉じる
          </button>
        </div>
      </Modal>
    </>
  );
}
